// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(after, areaIds, before, first, forSalePropertyTypes, forSaleStatuses, keywords, last, maxBeds, maxPrice, minBeds, minPrice, offMlsOnly, rentalMode, rentalPropertyTypes, rentalStatuses, sortOrder) {
  return {
    after: after,
    areaIds: areaIds,
    before: before,
    first: first,
    forSalePropertyTypes: forSalePropertyTypes,
    forSaleStatuses: forSaleStatuses,
    keywords: keywords,
    last: last,
    maxBeds: maxBeds,
    maxPrice: maxPrice,
    minBeds: minBeds,
    minPrice: minPrice,
    offMlsOnly: offMlsOnly,
    rentalMode: rentalMode,
    rentalPropertyTypes: rentalPropertyTypes,
    rentalStatuses: rentalStatuses,
    sortOrder: sortOrder
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function forSalePropertyV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "UNDER_CONTRACT" || $$enum === "SOLD") {
    return $$enum;
  }
}

let forSalePropertyV5FilterableStatus_fromString = forSalePropertyV5FilterableStatus_decode;

function propertySearchSortOrder_decode($$enum) {
  if ($$enum === "RECENTLY_BROADCAST" || $$enum === "RECENTLY_UPDATED") {
    return $$enum;
  }
}

let propertySearchSortOrder_fromString = propertySearchSortOrder_decode;

function rentalPropertyFilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "RENTED") {
    return $$enum;
  }
}

let rentalPropertyFilterableStatus_fromString = rentalPropertyFilterableStatus_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  forSalePropertyV5FilterableStatus_decode: forSalePropertyV5FilterableStatus_decode,
  forSalePropertyV5FilterableStatus_fromString: forSalePropertyV5FilterableStatus_fromString,
  propertySearchSortOrder_decode: propertySearchSortOrder_decode,
  propertySearchSortOrder_fromString: propertySearchSortOrder_fromString,
  rentalPropertyFilterableStatus_decode: rentalPropertyFilterableStatus_decode,
  rentalPropertyFilterableStatus_fromString: rentalPropertyFilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areaIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSalePropertyTypes"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSaleStatuses"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keywords"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxBeds"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxPrice"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minBeds"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minPrice"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offMlsOnly"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalMode"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalPropertyTypes"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalStatuses"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortOrder"
},
v17 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v18 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v19 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v20 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v21 = [
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "kind": "Variable",
  "name": "areaIds",
  "variableName": "areaIds"
},
v23 = {
  "kind": "Variable",
  "name": "keywords",
  "variableName": "keywords"
},
v24 = {
  "kind": "Variable",
  "name": "maxBeds",
  "variableName": "maxBeds"
},
v25 = {
  "kind": "Variable",
  "name": "maxPrice",
  "variableName": "maxPrice"
},
v26 = {
  "kind": "Variable",
  "name": "minBeds",
  "variableName": "minBeds"
},
v27 = {
  "kind": "Variable",
  "name": "minPrice",
  "variableName": "minPrice"
},
v28 = {
  "kind": "Variable",
  "name": "offMlsOnly",
  "variableName": "offMlsOnly"
},
v29 = {
  "kind": "Variable",
  "name": "sortOrder",
  "variableName": "sortOrder"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v31/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v38 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "beds",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "baths",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "halfBaths",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lotSize",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "livingArea",
    "storageKey": null
  },
  (v37/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": (v38/*: any*/),
  "type": "CondoProperty",
  "abstractKey": null
},
v40 = {
  "kind": "InlineFragment",
  "selections": (v38/*: any*/),
  "type": "SingleFamilyProperty",
  "abstractKey": null
},
v41 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v37/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brokerage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v41/*: any*/),
            {
              "kind": "Literal",
              "name": "width",
              "value": 60
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipStatus",
      "storageKey": null
    },
    (v42/*: any*/)
  ],
  "storageKey": null
},
v44 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v46 = [
  (v34/*: any*/),
  (v42/*: any*/)
],
v47 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v48 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isPropertyPrice"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Price",
              "kind": "LinkedField",
              "name": "minPrice",
              "plural": false,
              "selections": (v47/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Price",
              "kind": "LinkedField",
              "name": "maxPrice",
              "plural": false,
              "selections": (v47/*: any*/),
              "storageKey": null
            }
          ],
          "type": "PriceRange",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Price",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "format",
                      "value": "FULL"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "formatted",
                  "storageKey": "formatted(format:\"FULL\")"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ExactPrice",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    (v35/*: any*/),
    {
      "alias": null,
      "args": (v44/*: any*/),
      "concreteType": "PropertyImageConnection",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PropertyImageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageAttachment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "crop",
                      "value": false
                    },
                    {
                      "kind": "Literal",
                      "name": "embed",
                      "value": true
                    },
                    {
                      "kind": "Literal",
                      "name": "height",
                      "value": 468
                    },
                    (v41/*: any*/),
                    {
                      "kind": "Literal",
                      "name": "width",
                      "value": 648
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                (v42/*: any*/),
                (v35/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            (v30/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "images(first:1)"
    },
    {
      "alias": null,
      "args": (v44/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "PropertySearchCard_images",
      "kind": "LinkedHandle",
      "name": "images"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "mlsPlan",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "onMlsAt",
              "storageKey": null
            }
          ],
          "type": "ListOnMlsAsActive",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "activeOnMlsOn",
              "storageKey": null
            }
          ],
          "type": "ListOnMlsAsComingSoon",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeOnMlsSince",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "propertyLocation",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v45/*: any*/)
          ],
          "type": "PropertyLocationWithHiddenAddress",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v45/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibilityRule",
              "storageKey": null
            }
          ],
          "type": "PropertyLocationWithVisibleAddress",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "broadcastAt",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "agentV2Id",
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "agentV2",
          "plural": false,
          "selections": [
            (v35/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": (v46/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "VisibleForSalePropertyAgent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        (v48/*: any*/)
      ],
      "type": "ForSalePropertyV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "agentId",
          "args": null,
          "concreteType": "Agent",
          "kind": "LinkedField",
          "name": "agent",
          "plural": false,
          "selections": (v46/*: any*/),
          "storageKey": null
        },
        (v48/*: any*/)
      ],
      "type": "RentalPropertyV5",
      "abstractKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertiesPageRelayQuery",
    "selections": [
      {
        "args": (v21/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayForSale_query"
      },
      {
        "args": (v21/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayRental_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v6/*: any*/),
      (v12/*: any*/),
      (v16/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v13/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "PropertiesPageRelayQuery",
    "selections": [
      {
        "condition": "rentalMode",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v17/*: any*/),
              (v22/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v23/*: any*/),
              (v20/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "forSalePropertyTypes"
              },
              (v29/*: any*/),
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "forSaleStatuses"
              }
            ],
            "concreteType": "ForSalePropertyV5Connection",
            "kind": "LinkedField",
            "name": "searchForSaleProperties",
            "plural": false,
            "selections": [
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSalePropertyV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForSalePropertyV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v36/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": "size",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lotSize",
                                "storageKey": null
                              },
                              (v37/*: any*/)
                            ],
                            "type": "LotProperty",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfUnits",
                                "storageKey": null
                              },
                              (v37/*: any*/)
                            ],
                            "type": "MultiUnitProperty",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentV2",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/)
                            ],
                            "type": "VisibleForSalePropertyAgent",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/),
                      (v49/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "rentalMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v17/*: any*/),
              (v22/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v23/*: any*/),
              (v20/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "rentalPropertyTypes"
              },
              (v29/*: any*/),
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "rentalStatuses"
              }
            ],
            "concreteType": "RentalPropertyV5Connection",
            "kind": "LinkedField",
            "name": "searchRentalProperties",
            "plural": false,
            "selections": [
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalPropertyV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RentalPropertyV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v36/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/),
                      (v42/*: any*/),
                      (v49/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "29747b0f43faa9ac9e02350072ce6b24",
    "id": null,
    "metadata": {},
    "name": "PropertiesPageRelayQuery",
    "operationKind": "query",
    "text": "query PropertiesPageRelayQuery(\n  $areaIds: [ID!]!\n  $maxBeds: Int\n  $minBeds: Int\n  $forSalePropertyTypes: [ForSalePropertyTypeEnumV5!]\n  $forSaleStatuses: [ForSalePropertyV5FilterableStatus!]\n  $rentalPropertyTypes: [RentalPropertyTypeEnumV5!]\n  $rentalStatuses: [RentalPropertyFilterableStatus!]\n  $maxPrice: Int\n  $minPrice: Int\n  $keywords: [String!]\n  $offMlsOnly: Boolean\n  $sortOrder: PropertySearchSortOrder\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $rentalMode: Boolean!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...PropertiesPageRelayForSale_query_pbnwq\n  ...PropertiesPageRelayRental_query_pbnwq\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  membershipStatus\n}\n\nfragment CondoPropertyAttributes_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSize\n  livingArea\n  displayName\n}\n\nfragment ForSalePropertyAttributes_property on ForSalePropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n    ... on LotProperty {\n      ...LotPropertyAttributes_lotProperty\n    }\n    ... on MultiUnitProperty {\n      ...MultiUnitPropertyAttributes_multiUnitProperty\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_Agent_forSalePropertyV5 on ForSalePropertyV5 {\n  agentV2 {\n    __typename\n    ... on VisibleForSalePropertyAgent {\n      agent {\n        ...AgentInfo_agent\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_StatusLabel_forSalePropertyV5 on ForSalePropertyV5 {\n  ...PropertyMlsLabel_propertyV5\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on SoldProperty {\n      __typename\n    }\n    ... on UnderContractProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_forSalePropertyV5 on ForSalePropertyV5 {\n  id\n  ...PropertySearchResultCard_propertyV5\n  ...ForSalePropertySearchResult_StatusLabel_forSalePropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...PropertyPrice_property_1tj01C\n  ...ForSalePropertyAttributes_property\n  ...ForSalePropertySearchResult_Agent_forSalePropertyV5\n  ...PropertySearchResultTimestamp_propertyV5\n  ...PropertySearchResultActions_propertyV5\n  ...UseShouldShowPropertyDetails_propertyV5\n}\n\nfragment LotPropertyAttributes_lotProperty on LotProperty {\n  size: lotSize\n  displayName\n}\n\nfragment MultiUnitPropertyAttributes_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment PropertiesPageRelayForSale_query_pbnwq on Query {\n  searchForSaleProperties(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $forSalePropertyTypes, statuses: $forSaleStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @skip(if: $rentalMode) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...ForSalePropertySearchResult_forSalePropertyV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PropertiesPageRelayRental_query_pbnwq on Query {\n  searchRentalProperties(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $rentalPropertyTypes, statuses: $rentalStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @include(if: $rentalMode) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...RentalPropertySearchResult_rentalPropertyV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PropertyLocationForCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyMlsLabel_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n    ... on NoMlsPlan {\n      __typename\n    }\n  }\n  activeOnMlsSince\n}\n\nfragment PropertyPrice_price_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n}\n\nfragment PropertyPrice_propertyPrice_1tj01C on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: SHORT)\n    }\n    maxPrice {\n      formatted(format: SHORT)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment PropertyPrice_property_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n  ... on RentalPropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n}\n\nfragment PropertySearchResultActions_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  id\n  ... on ForSalePropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n}\n\nfragment PropertySearchResultCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  images(first: 1) {\n    edges {\n      node {\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        key\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment PropertySearchResultTimestamp_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  updatedAt\n  broadcastAt\n}\n\nfragment RentalPropertyAttributes_property on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n  }\n}\n\nfragment RentalPropertySearchResult_Agent_rentalPropertyV5 on RentalPropertyV5 {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment RentalPropertySearchResult_StatusLabel_rentalPropertyV5 on RentalPropertyV5 {\n  ...PropertyMlsLabel_propertyV5\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on RentedProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment RentalPropertySearchResult_rentalPropertyV5 on RentalPropertyV5 {\n  id\n  ...PropertySearchResultCard_propertyV5\n  ...RentalPropertySearchResult_StatusLabel_rentalPropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...PropertyPrice_property_1tj01C\n  ...RentalPropertyAttributes_property\n  ...RentalPropertySearchResult_Agent_rentalPropertyV5\n  ...PropertySearchResultTimestamp_propertyV5\n  ...PropertySearchResultActions_propertyV5\n  ...UseShouldShowPropertyDetails_propertyV5\n}\n\nfragment SingleFamilyPropertyAttributes_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSize\n  livingArea\n  displayName\n}\n\nfragment UseShouldShowPropertyDetails_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    agentV2Id: agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          id\n          nodeId\n        }\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    agentId: agent {\n      id\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
